export default {
    name_asc: 'Tên A-Z',
    name_desc: 'Tên Z-A',
    price_asc: 'Giá thấp đến cao',
    price_desc: 'Giá cao đến thấp',
    selling: 'Bán chạy',
    latest: 'Mới nhất'
}